import { TextField } from "@mui/material";
import "./App.css";
import Allpokemon from "./components/Allpokemon";
import Header from "./components/Header.jsx";
import Main from "./components/Main";
function App() {
  return (
    <div className="App">
      <Header />
      <Main />
      <a
        href="https://www.flaticon.com/free-icons/pokemon"
        title="pokemon icons"
      >
        Pokemon icons created by Roundicons Freebies - Flaticon
      </a>
    </div>
  );
}

export default App;
